import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { SOCIAL_NETWORKS, shareMappingPath, } from '../../../../../widget/constants/social-networks';
import { buildUrl, getOrigin, getBsi, openPopup } from '../../../../../common';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import TwitterIcon from '../../../../../icons/compiled/components/TwitterIcon';
export class Twitter extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { instanceInfo, videoId, channelId, descriptionText, canShareContent, content, } = this.props;
            const { instanceId, componentId, sitePageId, siteUrl, biToken } = instanceInfo;
            const baseUrl = getOrigin(siteUrl);
            const shareProxyUrl = buildUrl(`${baseUrl}/${shareMappingPath}/${sitePageId}`, {
                'instance-id': instanceId,
                'component-id': componentId,
                'channel-id': channelId,
                'video-id': videoId,
                'bi-token': biToken,
                bsi: getBsi(),
            });
            if (canShareContent) {
                const url = buildUrl('https://twitter.com/intent/tweet', {
                    // eslint-disable-next-line
                    original_referer: siteUrl,
                    text: descriptionText
                        .replace('{siteUrl}', shareProxyUrl)
                        .replace('{title}', content.title),
                });
                openPopup(url);
            }
            this.props.onShare(SOCIAL_NETWORKS.TWITTER);
        };
    }
    render() {
        const { className, dataHook, ariaLabel, tooltip } = this.props;
        return (React.createElement(Tooltip, { content: tooltip },
            React.createElement("button", { onClick: this.onClick, "data-hook": dataHook, className: className, "aria-label": ariaLabel },
                React.createElement(InlineIcon, { icon: React.createElement(TwitterIcon, null), className: parentStyles.icon }))));
    }
}
Twitter.propTypes = {
    dataHook: PropTypes.string,
    onShare: PropTypes.func,
    content: PropTypes.object,
    className: PropTypes.string,
    descriptionText: PropTypes.string,
    canShareContent: PropTypes.bool,
    tooltip: PropTypes.node,
    ariaLabel: PropTypes.string,
    videoId: PropTypes.string,
    channelId: PropTypes.string,
    instanceInfo: PropTypes.shape({
        instanceId: PropTypes.string,
        componentId: PropTypes.string,
        sitePageId: PropTypes.string,
        siteUrl: PropTypes.string,
    }),
};
Twitter.defaultProps = {
    onShare: noop,
};
//# sourceMappingURL=twitter.js.map